var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 2.5A3.5 3.5 0 0 0 2.5 6v12A3.5 3.5 0 0 0 6 21.5h12a3.5 3.5 0 0 0 3.5-3.5V6A3.5 3.5 0 0 0 18 2.5H6Zm13.5 4.75a1.75 1.75 0 0 1-3.161 1.035l-3.841 1.372a1.75 1.75 0 0 1-2.146 1.798l-2.336 4.087a1.75 1.75 0 1 1-.868-.496l2.336-4.088a1.75 1.75 0 1 1 2.677-2.243l3.841-1.372A1.75 1.75 0 1 1 19.5 7.25Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsB);
export default __webpack_public_path__ + "static/media/analytics_b.00a6a27d349725b93289b173ed2bf1bf.svg";
export { ForwardRef as ReactComponent };